import FlashMessage from "~/components/FlashMessage";
import { Flash as TFlash } from "~/entities/flash/types";

const Flash: React.FC<{ flash: TFlash | null }> = ({ flash }) => {
  if (!flash) return;

  return (
    <FlashMessage
      kind={flash.kind}
      message={flash.message}
    />
  );
};

export default Flash;
